import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      quickLinks: 'Quick Links',
      company: 'Company',
      rights: 'All rights reserved.',
      tagline: 'Indian Excellence for Global Markets'
    },
    vi: {
      quickLinks: 'Liên kết nhanh',
      company: 'Công ty',
      rights: 'Bảo lưu mọi quyền.',
      tagline: 'Sự xuất sắc của Ấn Độ cho thị trường toàn cầu'
    }
  };

  const t = content[language];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div className="col-span-1">
            <div className="mb-4">
              <img 
                src="/logo.png" 
                alt="IVARME" 
                className="h-14 w-auto mb-3"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <p className="text-sm text-gray-400 mb-6">{t.tagline}</p>
            <div className="space-y-2 text-xs text-gray-400">
              <p>{companyInfo.udyam}</p>
              <p>{companyInfo.gst}</p>
              <p>{companyInfo.iec}</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t.quickLinks}</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:text-[#adbccb] transition-colors duration-200">Home</Link></li>
              <li><Link to="/about" className="text-sm hover:text-[#adbccb] transition-colors duration-200">About Us</Link></li>
              <li><Link to="/services" className="text-sm hover:text-[#adbccb] transition-colors duration-200">Services</Link></li>
              <li><Link to="/products" className="text-sm hover:text-[#adbccb] transition-colors duration-200">Products</Link></li>
              <li><Link to="/faq" className="text-sm hover:text-[#adbccb] transition-colors duration-200">FAQ</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-[#adbccb]" />
                <span>{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <Mail className="w-4 h-4 flex-shrink-0 text-[#adbccb]" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-[#adbccb] transition-colors duration-200">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#adbccb]" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-[#adbccb] transition-colors duration-200">
                  {companyInfo.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} {companyInfo.name}. {t.rights}
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy" className="text-gray-500 hover:text-[#adbccb] transition-colors duration-200">Privacy Policy</Link>
              <Link to="/terms" className="text-gray-500 hover:text-[#adbccb] transition-colors duration-200">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
